/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_Reply_SuccessInputs */

const en_admin_tickets_reply_success = /** @type {(inputs: Admin_Tickets_Reply_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reply sent`)
};

/**
* | output |
* | --- |
* | "Reply sent" |
*
* @param {Admin_Tickets_Reply_SuccessInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_tickets_reply_success = /** @type {((inputs?: Admin_Tickets_Reply_SuccessInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_Reply_SuccessInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_tickets_reply_success(inputs)
});
export { admin_tickets_reply_success as "admin.tickets.reply_success" }